var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-toolbar",
        { attrs: { dense: "", flat: "" } },
        [
          _c(
            "v-btn-toggle",
            {
              attrs: { mandatory: "", dense: "", color: "primary" },
              model: {
                value: _vm.computedSettings.viewMode,
                callback: function ($$v) {
                  _vm.$set(_vm.computedSettings, "viewMode", $$v)
                },
                expression: "computedSettings.viewMode",
              },
            },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              {
                                attrs: { text: "", value: "single", small: "" },
                              },
                              on
                            ),
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  attrs: { color: "primary" },
                                },
                                [_vm._v("mdi-text-box")]
                              ),
                              _vm._v(" Single Project "),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v("Single project dashboard")])]
              ),
              _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              {
                                attrs: {
                                  text: "",
                                  value: "multiple",
                                  small: "",
                                },
                              },
                              on
                            ),
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  attrs: { color: "primary" },
                                },
                                [_vm._v("mdi-text-box-multiple")]
                              ),
                              _vm._v(" Multiple Projects "),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v("Multiple projects dashboard")])]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-divider"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }